<template>
  <div>
    <b-card
      v-if="Object.keys(data).length > 0"
      no-body
      class="mb-0"
    >
      <b-card-header
        class="d-flex justify-content-between align-items-start mb-0 pl-1 pr-1 pt-1 p-0"
      >
        <div>
          <h1 class="contract-info-name mb-0">
            {{ data.apenom }}
          </h1>
          <small
            v-if="
              data.sobrenombre != null && data.sobrenombre != ''
            "
            class="text-muted"
          >[ {{ data.sobrenombre }} ]</small>
        </div>
        <contract-balance
          :key="data.idcontrato"
          :idcontrato="data.idcontrato"
        />
      </b-card-header>
      <b-row class="ml-1 mt-0">
        <b-col
          cols="12"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :src="data.avatar"
              :text="avatarText(data.apenom)"
              size="100px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <div class="mb-0">
                <h5 class="mb-0">
                  {{ data.codigo }}
                </h5>
                <a
                  :href="`mailto:${data.email}`"
                  class="card-text"
                >{{ data.email }}</a>
              </div>
              <div
                v-if="data.contrato_estado != null"
                class="d-flex flex-wrap mt-50"
              >
                <b-badge
                  pill
                  :variant="data.contrato_estado.class"
                >
                  {{ data.codigo }} -
                  {{ data.contrato_estado.estado }}
                </b-badge>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1">
            <contract-buttons
              :data="data"
              @reload="reload()"
            />
          </div>

          <div class="my-1">
            <contract-actions :data="data" />
          </div>

          <div class="my-1">
            <div class="contract-field">
              <span class="contract-field-label">Localidad</span>
              <span class="contract-field-value">
                <template
                  v-if="data.localidad != null"
                >{{ data.localidad.localidad }} -
                </template>
                <template v-if="data.sector != null">{{
                  data.sector.sector
                }}</template>
              </span>
            </div>
            <div
              v-if="data.direccion != ''"
              class="contract-field"
            >
              <span class="contract-field-label">Dirección</span>
              <span class="contract-field-value">{{
                data.direccion
              }}</span>
            </div>
            <div
              v-if="data.referencia != ''"
              class="contract-field"
            >
              <span class="contract-field-label">Referencia</span>
              <span class="contract-field-value">{{
                data.referencia
              }}</span>
            </div>
          </div>
        </b-col>

        <!-- Right Col: Table -->
        <b-col
          cols="12"
          xl="6"
        >
          <div class="mb-1">
            <contract-values :data="data" />
          </div>
          <div>
            <div
              v-if="data.sobrenombre != null"
              class="contract-field"
            >
              <span class="contract-field-label">Alias</span>
              <span class="contract-field-value">{{
                data.sobrenombre
              }}</span>
            </div>
            <div
              v-if="data.ruc != ''"
              class="contract-field"
            >
              <span class="contract-field-label">NUI</span>
              <span class="contract-field-value">{{
                data.ruc
              }}</span>
            </div>
            <div
              v-if="data.telefono != ''"
              class="contract-field"
            >
              <span class="contract-field-label">Telefono</span>
              <span class="contract-field-value">{{
                data.telefono
              }}</span>
            </div>
            <div class="contract-field">
              <span class="contract-field-label">Fecha</span>
              <span class="contract-field-value">{{
                data.fecha_contrato | dateFormat
              }}</span>
            </div>
            <div
              v-if="data.comprobante != null"
              class="contract-field"
            >
              <span
                class="contract-field-label"
              >Comprobante</span>
              <span class="contract-field-value">{{
                data.comprobante.comprobante
              }}</span>
            </div>
          </div>
          <div class="mt-1 mb-1">
            <b-badge
              v-if="data.op_descuento"
              variant="warning"
            >
              Tarifa Especial: {{ data.descuento_v }} (
              {{ data.descuento_p }}% )
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { avatarText } from "@core/utils/filter"
import { BAvatar, BBadge, BCard, BCardHeader, BCol, BRow } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import ContractActions from "./ContractActions.vue"
import ContractBalance from "./ContractBalance.vue"
import ContractButtons from "./ContractButtons.vue"
import ContractValues from "./ContractValues.vue"

export default {
  components: {
    BCard,
    BCardHeader,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    ContractButtons,
    ContractActions,
    ContractValues,
    ContractBalance,
  },
  directives: {
    Ripple,
  },
  filters: {
    dateFormat(string) {
      return string.split("-").reverse().join("/")
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    reload() {
      this.$emit("reload")
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-info-name {
    font-size: 1.5rem;
    font-weight: 700;
}

.contract-field {
    padding: 0.5rem 0;
    border-bottom: 1px solid var(--tm-border);
    .contract-field-label {
        color: var(--tm-text-muted);
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        display: block;
    }
    .contract-field-value {
        color: var(--tm-text);
        font-size: 0.9rem;
    }
    &:last-child {
        border-bottom: 0;
    }
}
</style>
